import { imgUrl } from "../../../../service/apis";
import { Circle as CircleStyle, Fill, Stroke, Style, Icon, Text } from "ol/style";
import { fetchGet } from "../../../../config/axiosConfig";

export async function addFishIcon(iconHelper, fish) {
    let { addIcon } = iconHelper
    let fishUrl = imgUrl + fish.fishPic
    let coord = [fish.calc_lon, fish.calc_lat]
    let pdx, pdy = 20;
    let highSrc = await ceateHighLight(fishUrl, { length: 20, strokeWidth: 5, pdx, pdy })
    let fishFeature = addIcon(
        coord, {
            src: fishUrl,
            anchor: [0.5, 0.5],
            scale: 0.5,
        },
        "fish",
        fish
    );
    let normalStyle = new Style({
        image: new Icon({
            src: fishUrl,
            scale: 0.3,
            anchor: [0.5, 0.5],
        }),
    });
    let highStyle = new Style({
        image: new Icon({
            img: highSrc,
            imgSize: [highSrc.width, highSrc.height],
            scale: 0.3,
            anchor: [0.5, 0.5],
        }),
    });
    fishFeature.set("styles", { normalStyle, highStyle })
    fishFeature.setStyle(normalStyle)
    return fishFeature

}
export function ceateHighLight(src, options = {}) {
    let img = document.createElement("img")
        // fetchGet(src).then(res => {
        // console.log("图片", res)
        // })
    img.src = src
    return new Promise((resolve) => {
        img.onload = () => {
            // img.crossOrigin = "Anonymous"
            // resolve("")
            resolve(drawEffect(img, options))
        }
    })

}
export function drawEffect(img, options) {
    if (!img) return ""
    let { width, height } = img
    let { color, strokeWidth, pdx, pdy, length } = options
    let dx = pdx || 10,
        dy = pdy || 10,
        strokeW = strokeWidth || 2;
    let [rw, rh] = [width + dx, height + dy]
    let canvas = createCanvas(width + dx, height + dy)
    let ctx = canvas.getContext("2d")
    ctx.drawImage(img, dx / 2, dy / 2)
    let len = Math.min(length || 10, width / 2, height / 2)
    ctx.fillStyle = color || "red"
    ctx.lineWidth = strokeW || 2
    ctx.strokeStyle = color || "red"
    let sw = strokeW / 2
    ctx.beginPath()
    ctx.moveTo(sw, sw + len)
    ctx.lineTo(sw, sw)
    ctx.lineTo(sw + len, sw)

    ctx.moveTo(rw - sw, sw + len)
    ctx.lineTo(rw - sw, sw)
    ctx.lineTo(rw - sw - len, sw)

    ctx.moveTo(rw - sw, rh - sw - len)
    ctx.lineTo(rw - sw, rh - sw)
    ctx.lineTo(rw - sw - len, rh - sw)

    ctx.moveTo(sw, rh - sw - len)
    ctx.lineTo(sw, rh - sw)
    ctx.lineTo(sw + len, rh - sw)

    ctx.stroke()

    return canvas
}

function createCanvas(w, h) {
    let canvas = document.createElement("canvas")
    canvas.width = w
    canvas.height = h
    return canvas
}


// WEBPACK FOOTER //
// ./src/pages/tablePanels/fish/fishMethods/fishLayer.js